import React from 'react'
import { ComponentProps } from '../../types/types'

const PrintProps = (componentProps: ComponentProps) => {
  try {
    return <code>{JSON.stringify(componentProps)}</code>
  } catch (e) {
    console.error(e)
    return <code>{e as any}</code>
  }
}

export default PrintProps
